import file from './file';
import pdf from './pdf';
import geolocation from './geolocation';

export default {
    file,
    pdf,
    geolocation,
};
